@if (!hatInhalt) {
	<p class="text-muted fst-italic mt-3">
		Für diesen Punkt sind noch keine Horizont- oder Substratzeilen mit Tiefe erfasst.
		Sobald im Reiter „Boden" eine Tiefe steht, entsteht hier das Grubenbild.
	</p>
} @else {
	<!-- Die Bodenform steht UEBER allem: Sie ist das Ergebnis, das aus dem
	     Profil abgeleitet wird, also die Ueberschrift des Ganzen. In der rechten
	     Spalte waere sie auf einem schmalen Schirm unter das Bild gerutscht
	     (Nutzer-Entscheidung 19.09.2026). -->
	<section class="bodenform-kopf">
		@if (bodenformOben) {
			<div class="bodenform-haupt">{{ bodenformOben }}</div>
		}
		@if (stfgText) {
			<div class="bodenform-stfg">{{ stfgText }}</div>
		}
		@if (!bodenformOben && !stfgText) {
			<div class="bodenform-leer">Keine Bodenform erfasst.</div>
		}
	</section>

	<!-- Die Anzeige-Schalter (Nutzer-Wunsch 24.09.2026). Ein Haken schaltet um
	     und zeichnet sofort neu; die gewaehlte Schicht bleibt dabei stehen.
	     „Grenzlinien" meint beide Sorten: die dicken an den Horizontgrenzen und
	     die feinen Fugen an den Substratgrenzen. Sind Horizonte UND Substrate
	     aus, gibt es keine Grenze mehr - der Haken ist dann gesperrt, behaelt
	     aber seinen Stand. -->
	<div class="grubenbild-schalter" role="group" aria-label="Anzeige des Grubenbildes">
		<div class="form-check form-check-inline">
			<input class="form-check-input" type="checkbox" id="gb-schalter-horizonte"
				[checked]="horizonte" (change)="horizonte = !horizonte; neuZeichnen()">
			<label class="form-check-label" for="gb-schalter-horizonte">Horizonte</label>
		</div>
		<div class="form-check form-check-inline">
			<input class="form-check-input" type="checkbox" id="gb-schalter-substrate"
				[checked]="substrate" (change)="substrate = !substrate; neuZeichnen()">
			<label class="form-check-label" for="gb-schalter-substrate">Substrate</label>
		</div>
		<div class="form-check form-check-inline">
			<input class="form-check-input" type="checkbox" id="gb-schalter-grenzlinien"
				[checked]="grenzlinien" [disabled]="!horizonte && !substrate"
				(change)="grenzlinien = !grenzlinien; neuZeichnen()">
			<label class="form-check-label" for="gb-schalter-grenzlinien">Grenzlinien</label>
		</div>
		<div class="form-check form-check-inline">
			<input class="form-check-input" type="checkbox" id="gb-schalter-wurzeln"
				[checked]="wurzeln" (change)="wurzeln = !wurzeln; neuZeichnen()">
			<label class="form-check-label" for="gb-schalter-wurzeln">Wurzeln</label>
		</div>
	</div>

	<div class="grubenbild-inhalt" #inhalt>
		<div class="grubenbild-rahmen" #bild></div>

		<!-- Die Humusauflage vergroessert. Liegt ueber dem Bild und nimmt am
		     Flex-Umbruch nicht teil (absolut gesetzt). -->
		@if (lupe; as l) {
			<div class="auflage-lupe" role="dialog" aria-label="Humusauflage, vergrößert"
				[style.left.px]="l.x" [style.top.px]="l.y" [style.width.px]="l.breite">
				<div class="auflage-lupe-kopf">
					<span>Humusauflage, vergrößert</span>
					<button type="button" class="btn-close" aria-label="Schließen" (click)="lupeSchliessen()"></button>
				</div>
				<div class="auflage-lupe-bild" #lupeBild></div>
				<p class="auflage-lupe-fuss">Mächtigkeiten im richtigen Verhältnis, Blätter und Krümel schematisch. Erläuterungen nach SEA 95, Teil B, Darst. B 3-12.</p>
			</div>
		}

		<div class="grubenbild-rechts">
			<p class="hinweis-zeigen">Zeigen erklärt die Substratschicht, ein Klick wählt den Horizont.</p>

			<aside class="grubenbild-tafel" #tafel>
			@if (gewaehlteAuflage; as a) {
				<h2 class="tafel-kopf">
					<span>Humusauflage</span>
					<span class="text-muted fw-normal">{{ a.maechtigkeit }} cm</span>
				</h2>
				<table class="tafel-werte">
					@for (w of auflageAngaben; track spurAngabe($index, w)) {
						<tr><td>{{ w.name }}</td><td>{{ w.wert }}</td></tr>
					}
				</table>
				<p class="tafel-fuss">
					Ol, Of und Oh stehen nicht in der Horizontfolge, sondern als drei feste
					Mächtigkeiten am Datensatz. Im Bild liegen sie maßstabsgerecht über der
					Geländeoberfläche.
				</p>
				<!-- Filz (filz-tiefen.ts): Die Auflage gehoert zum Profil, das Massband
				     beginnt an ihrer Oberkante, und jede Tiefe in dieser Tafel zaehlt ab dort. -->
				@if (versatz) {
					<p class="tafel-fuss">
						Filz: Die Auflage gehört zum Profil. Das Maßband beginnt an ihrer
						Oberkante, und alle Tiefen hier zählen ab dort (+{{ versatz }} cm).
						Eingegeben sind sie ab Oberkante Mineralboden.
					</p>
				}
			} @else if (gewaehlterHorizont; as h) {
				<h2 class="tafel-kopf">
					<span>{{ horizontName }}</span>
					<span class="text-muted fw-normal">{{ tiefe(h.von) }}–{{ tiefe(h.bis) }} cm, {{ h.bis - h.von }} cm mächtig</span>
				</h2>

				<div class="symbolreihe">
					@for (s of symbole; track s.roh) {
						<span class="symbolfeld" [style.background]="s.farbe" [style.color]="s.schrift">{{ s.roh }}</span>
					}
				</div>
				<table class="tafel-werte">
					@for (s of symbole; track s.roh) {
						<tr><td>{{ s.roh }}</td><td>{{ s.text }}</td></tr>
					}
					@if (praegend) {
						<tr>
							<td>prägend</td>
							<td>{{ praegend }} – bei Mischhorizonten steht der prägende Teil an letzter Stelle</td>
						</tr>
					}
				</table>

				<h3 class="tafel-ueberschrift">
					@if (substratSchichten.length === 1) { Substratschicht }
					@else { Substratschichten ({{ substratSchichten.length }}) }
				</h3>
				@if (substratSchichten.length) {
					@for (s of substratSchichten; track s.von) {
						<div class="substratschicht">
							<div class="substratschicht-kopf">
								<span class="substratschicht-tiefe">{{ tiefe(s.von) }}–{{ tiefe(s.bis) }} cm</span>
								<span class="substratschicht-art">{{ s.zeile.substrat }}</span>
							</div>
							<table class="tafel-werte">
								@for (w of angabenZu(s.zeile, s.lage); track spurAngabe($index, w)) {
									<tr><td>{{ w.name }}</td><td>{{ w.wert }}</td></tr>
								}
							</table>
						</div>
					}
				} @else {
					<p class="text-muted fst-italic mb-0">In diesem Horizont ist keine Substratzeile erfasst.</p>
				}
			} @else {
				<h2 class="tafel-kopf"><span>Keine Schicht gewählt</span></h2>
				<p class="text-muted fst-italic">Auf eine Schicht im Bild tippen - sie zeigt den Horizont mit allen Substratschichten.</p>
			}
			</aside>
		</div>
	</div>

	<section class="grubenbild-legende">
		<h3 class="tafel-ueberschrift">Horizonte in diesem Profil</h3>
		<div class="legendenliste">
			@for (e of legende; track spurLegende($index, e)) {
				<div class="legendeneintrag">
					<span class="legendenfeld" [style.background]="e.farbe"></span>
					<span><strong>{{ e.symbol }}</strong> {{ e.text }}</span>
				</div>
			}
		</div>
		<p class="tafel-fuss">
			<strong>Woher die Farben kommen.</strong> Die Farben sind eine Darstellungsentscheidung,
			damit sich die Horizonte unterscheiden lassen - keine Aussage über die wirkliche
			Bodenfarbe. Der Humusgehalt der Substratzeile dunkelt sie zusätzlich ab.
			<br>
			<strong>Wie Symbole gelesen werden</strong> (SEA 95 Teil A, 1.3.1, S. 40 f.): runde
			Klammern = schwache Ausprägung, nachgestelltes „r" = reliktischer Grundgley-Horizont,
			bei Mischhorizonten steht der prägende Teil an letzter Stelle, Bb wird mit Anteilen in
			Zehntelstufen angegeben.
			<br>
			<strong>Maßstab.</strong> Die Wand ist 1,50 m breit und zeigt die ganze Aufnahmetiefe,
			maßstabsgerecht in beiden Richtungen. Die Humusauflage steht über der Geländeoberfläche -
			außer bei einem Filz (Filz-Bodenform oder Auflage dicker als 11 cm): Dort gehört sie zum
			Profil, und das Maßband beginnt an der Oberkante des Ol.
			<br>
			<strong>Bänder.</strong> Wo ein Bb-Horizont über Substratzeilen liegt, die laut
			Wechsel-Haken miteinander wechseln, kommen Zahl und Dicke der Bänder aus diesen Zeilen:
			Die Kette nennt die beteiligten Substrate, ihre Mächtigkeiten das Mengenverhältnis. Auf
			wie viele einzelne Bänder sich das verteilt, sagen die Daten nicht - das ist eine
			Darstellung.
		</p>
	</section>
}

@if (tipp) {
	<div class="grubenbild-tipp" [style.left.px]="tippX + 16" [style.top.px]="tippY + 14">{{ tipp }}</div>
}
